export default __webpack_public_path__ + "static/media/kitchen4-afterE-1440w.60b7c036.avif";